import { useAuth } from '@/features/auth'
import Loading from '@/components/custom/loading'
import { Navigate, useLocation } from 'react-router-dom'

export const AuthGuard = ({ children }: { children: React.ReactNode }) => {
    const { user, loading } = useAuth()
    const location = useLocation()

    if (loading) {
        return (
            <div className="flex h-screen w-full items-center justify-center">
                <Loading />
            </div>
        )
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    return <>{children}</>
}
